import { v4 as uuid } from 'uuid';
import { useState, useRef } from 'react';
import TaskIcon from 'assets/icons/task';
import LabelList from '../utils/labelList';
import { useLocation } from 'react-router-dom';
import ConditionIcon from 'assets/icons/condition';
import { Box, Typography, Paper, TextField } from '@mui/material';
import { Handle, Position, useReactFlow, MarkerType } from '@xyflow/react';

const ConditionShape = ({ id, data }) => {
	const menuRef = useRef(null);
	const location = useLocation();

	const [showMenu, setShowMenu] = useState(false);
	const [isHovered, setIsHovered] = useState(false);
	const [isEditingNote, setIsEditingNote] = useState(false);
	const { addNodes, addEdges, getNode, setNodes } = useReactFlow();

	const isViewPage = location.pathname.includes('/work-flow/view');

	const currentNode = getNode(id);

	const handleAdd = ({ type }) => {
		const newId = uuid();

		const newNode = {
			type,
			id: newId,
			position: { x: currentNode?.position?.x + 250, y: type === 'solution_task' ? currentNode?.position?.y - 6.5 : currentNode?.position?.y },
			data: {
				label: type,
				mode: 'both',
			},
		};

		addNodes(newNode);

		addEdges({
			id: `${id}-${newId}`,
			source: id,
			target: newId,
			type: 'smoothstep',
			style: { strokeWidth: 2 },
			markerEnd: { type: MarkerType.ArrowClosed },
		});

		setNodes((nodes) => nodes.map((node) => (node.id === id ? { ...node, data: { ...node.data, hasChild: true } } : node)));

		setIsHovered(false);
		setShowMenu(false);
	};

	const handleChangeNote = (e) => {
		setNodes((nodes) =>
			nodes.map((node) => {
				if (node.id === id) {
					return {
						...node,
						data: { ...node.data, note: e.target.value },
					};
				}
				return node;
			})
		);
	};

	return (
		<Box
			onMouseEnter={() => {
				if (menuRef.current) {
					clearTimeout(menuRef.current);
					menuRef.current = null;
				}

				setIsHovered(true);
			}}
			onMouseLeave={() => {
				menuRef.current = setTimeout(() => {
					setIsHovered(false);
					setShowMenu(false);
				}, 500);
			}}
			sx={{
				position: 'relative',
				borderRadius: '20px',
				background: '#fff',
				border: '2px solid #d97706',
			}}
		>
			<Box
				sx={{
					zIndex: 5,
					top: ' -5px',
					left: 'px',
					// width: '15px',
					// height: '15px',
					display: 'flex',
					color: '#fff',
					alignItems: 'center',
					// borderRadius: '50%',
					borderRadius: '4px',
					fontSize: '8px',
					padding: '0px 2px',
					position: 'absolute',
					justifyContent: 'center',
					background: data?.isValid ? '#059669' : '#EF4444',
				}}
			>
				{data?.isValid ? (
					<>
						<span>C</span>
						{/* // <svg viewBox="0 0 24 24" fill="currentColor" width="10px" height="10px">
					// 	<path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path>
					// </svg> */}
					</>
				) : (
					<>
						<span>IC</span>
						{/* // <svg viewBox="0 0 24 24" fill="currentColor" width="10px" height="10px">
					// 	<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
					// </svg> */}
					</>
				)}
			</Box>

			<Box sx={{ padding: '16px 12px 0 12px' }}>
				<Typography fontWeight={400} fontSize={14} sx={{ color: '#d97706', textAlign: 'center' }}>
					{LabelList?.[data.label] ?? data?.label}
				</Typography>
			</Box>

			<Box sx={{ padding: '0 12px 16px 12px', maxWidth: '150px' }}>
				{/* <Typography fontWeight={400} fontSize={12} sx={{ color: '#6B7280', overflow: 'hidden' }}>
					Note: {data?.note ? data?.note : 'No note added'}
				</Typography> */}

				{isEditingNote ? (
					<TextField
						autoFocus
						multiline
						fullWidth
						className="nodrag"
						variant="standard"
						value={data?.note || ''}
						onChange={handleChangeNote}
						onBlur={() => setIsEditingNote(false)}
						InputProps={{
							disableUnderline: true,

							style: {
								padding: 0,
								fontSize: '9px',
								lineHeight: '1.5',
								color: '#374151',
								borderRadius: '4px',
								background: '#F9FAFB',
							},
						}}
						sx={{
							'& .MuiInputBase-root': { padding: '2px 4px' },
						}}
					/>
				) : (
					<Typography
						fontSize={9}
						fontWeight={400}
						onClick={(e) => e.stopPropagation()}
						onDoubleClick={(e) => {
							if (!isViewPage) {
								e.stopPropagation();

								setIsEditingNote(true);
							}
						}}
						sx={{
							cursor: 'text',
							minHeight: '18px',
							overflow: 'hidden',
							border: '1px solid transparent',
							color: data?.note ? '#374151' : '#9CA3AF',

							'&:hover': {
								borderRadius: '4px',
								border: '1px dashed #D1D5DB',
							},
						}}
					>
						{data?.note ? data?.note : 'Double click to add note...'}
					</Typography>
				)}
			</Box>

			{(data.mode === 'output' || data.mode === 'both') && <Handle type="target" position={Position.Left} isConnectable={!data?.locked} />}

			{(data.mode === 'input' || data.mode === 'both') && <Handle type="source" position={Position.Right} isConnectable={!data?.locked} />}

			{!data.hasChild && isHovered && !isViewPage && (
				<Box
					onClick={(e) => {
						e.stopPropagation();
						setShowMenu((prev) => !prev);
					}}
					sx={{
						zIndex: 10,
						bottom: '38%',
						right: '-10px',
						width: '20px',
						height: '20px',
						color: '#fff',
						display: 'flex',
						cursor: 'pointer',
						borderRadius: '50%',
						alignItems: 'center',
						position: 'absolute',
						background: '#0052CC',
						justifyContent: 'center',

						'&:hover': { background: '#0052CC' },
					}}
				>
					+
				</Box>
			)}

			{showMenu && (
				<Paper
					elevation={4}
					onMouseEnter={() => {
						if (menuRef.current) {
							clearTimeout(menuRef.current);
							menuRef.current = null;
						}
					}}
					onMouseLeave={() => {
						menuRef.current = setTimeout(() => {
							setIsHovered(false);
							setShowMenu(false);
						}, 500);
					}}
					sx={{
						zIndex: 20,
						bottom: '18%',
						right: '-85px',
						width: '70px',
						cursor: 'pointer',
						padding: '6px 6px',
						borderRadius: '2px',
						position: 'absolute',
					}}
				>
					<Box
						onClick={(e) => {
							e.stopPropagation();
							handleAdd({ type: 'solution_task' });
						}}
						sx={{
							gap: '4px',
							padding: '2px',
							fontSize: '8px',
							display: 'flex',
							alignItems: 'center',

							'&:hover': { background: '#F3F4F6' },
						}}
					>
						<TaskIcon color="#059669" width={10} height={10} /> Task
					</Box>

					<Box
						onClick={(e) => {
							e.stopPropagation();
							handleAdd({ type: 'condition' });
						}}
						sx={{
							gap: '4px',
							padding: '2px',
							fontSize: '8px',
							display: 'flex',
							alignItems: 'center',

							'&:hover': { background: '#F3F4F6' },
						}}
					>
						<ConditionIcon color="#d97706" width={10} height={10} /> Condition
					</Box>
				</Paper>
			)}
		</Box>
	);
};

export default ConditionShape;
